const session_expired = {
    title: 'Oturum Süresi Doldu',
    subtitle: 'Oturumunuzun süresi dolmuş ve bağlantınız kesilmiş olabilir. Yönetici konsolunda tekrar oturum açmak için aşağıdaki butona tıklayınız.',
    button: 'Yeniden Giriş Yap',
};
export default session_expired;
